import React, { useCallback, useEffect, useState } from "react";
import Editor, { createEditorStateWithText } from "draft-js-plugins-editor";
import { convertFromRaw, EditorState, ContentState } from "draft-js";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import i18n from "../../i18n";

const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: "border-box",
  },
  seeMore: {
    marginTop: "20px",
    color: "#DDE1E7",
    textDecoration: "underline",
  },
}));

function RichTextRenderer({ value, fromSlider }) {
  const classes = useStyles();
  const [editorState, setEditorState] = useState(createEditorStateWithText(""));
  const [multiRowData, setMultiRowData] = useState(false);
  const [fontSize, setFontSize] = useState("inherit");

  const getContentFromValue = useCallback(() => {
    if (value) {
      let val = value;
      if (!isNaN(val)) {
        setEditorState(createEditorStateWithText(val.toString()));
        return;
      }
      if (!val) {
        val = {};
      }
      if (!val.blocks) {
        val.blocks = [];
      }
      if (!val.entityMap) {
        val.entityMap = {};
      }
      if (val.blocks.length >= 3) {
        setFontSize("14px");
      } else {
        setFontSize("inherit");
      }
      if (fromSlider) {
        setFontSize("12px");
      }
      const regex = /\B\$question\w+?\s/gm;
      if (val.blocks.length > 3) {
        let previewVal = { ...val };
        let previewBlocks = [];
        previewBlocks.push(previewVal.blocks[0]);
        previewBlocks.push(previewVal.blocks[1]);
        previewBlocks.push(previewVal.blocks[2]);
        previewVal.blocks = previewBlocks;
        setMultiRowData(true);

        //filter out $question from the value - as there are not decorator to do it automatically
        const previewContent = convertFromRaw(previewVal);
        const previewValue = previewContent.getPlainText();
        const filteredPreviewValue = previewValue.replaceAll(regex, "");
        const filteredPreviewContent = ContentState.createFromText(
          filteredPreviewValue
        );
        const newPreviewState = EditorState.createWithContent(
          filteredPreviewContent
        );
        setEditorState(newPreviewState);
      } else {
        setMultiRowData(false);
        const content = convertFromRaw(val);
        const contentValue = content.getPlainText();
        const filteredValue = contentValue.replaceAll(regex, "");
        const filteredContent = ContentState.createFromText(filteredValue);
        const newState = EditorState.createWithContent(filteredContent);
        setEditorState(newState);
      }
    }
  }, [value, fromSlider]);

  useEffect(() => {
    getContentFromValue();
  }, [getContentFromValue]);

  const onChange = () => {
    return null;
  };

  return (
    <React.Fragment>
      <Grid className={classes.root} style={{ fontSize: fontSize }}>
        <Editor
          id="questionField"
          editorState={editorState}
          readOnly={true}
          onChange={onChange}
        />
      </Grid>
      {multiRowData && (
        <Grid className={classes.seeMore}>{i18n.t("default:_SEE_MORE")}</Grid>
      )}
    </React.Fragment>
  );
}

export default RichTextRenderer;
